"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var CoreCharge = function CoreCharge(_ref) {
  var charge = _ref.charge;

  if (parseFloat(charge) <= 0) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: 'green'
    }
  }, "+$", charge);
};

var _default = CoreCharge;
exports["default"] = _default;